import { render, staticRenderFns } from "./base-filters.vue?vue&type=template&id=c124d964&scoped=true"
import script from "./base-filters.vue?vue&type=script&lang=js"
export * from "./base-filters.vue?vue&type=script&lang=js"
import style0 from "./base-filters.vue?vue&type=style&index=0&id=c124d964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c124d964",
  null
  
)

export default component.exports